
const EmailIcon = ({ width = 15, height = 12, fill = 'currentColor', className = '' }) => {
  return (
    <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.399902" y="0.400391" width="15" height="9.75" rx="1" stroke="#0C0C0C" strokeWidth="0.8" strokeLinejoin="round" />
      <path d="M0.774902 0.775391L7.8999 5.65039L15.0249 0.775391" stroke="#0C0C0C" strokeWidth="0.8" strokeLinejoin="round" />
    </svg>
  )
}

export default EmailIcon
